import React, { Fragment, useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import CSSModules from 'react-css-modules';
import Popover from 'material-ui/Popover';
import size from 'lodash/size';

import { toggleElementInList } from '../../../../utils/arrayModify';
import { renderAddress } from '../../helpers/renderAddress';
import Checkbox from '../../../common/Checkbox';
import Button from '../../../Button';
import Icon from '../../../Icon';
import styles from './styles.styl';

function LocationPicker({
  formatMessage,
  filterList,
  onApply,
  activeLocations,
  isVirtualVisit,
}) {
  const [anchorEl, setAnchor] = useState(null);
  const [locations, setLocations] = useState(activeLocations);
  const locationSize = size(locations);
  const showCounter = locationSize !== 0 && locationSize !== size(filterList);

  useEffect(() => {
    setLocations(activeLocations);
  }, [activeLocations]);

  const handleOpen = event => setAnchor(event.currentTarget);
  const handleClose = () => {
    setAnchor(null);
    setLocations(activeLocations);
  };
  const handleSelect = id => setLocations(toggleElementInList(locations, id));
  const handleApply = () => {
    setAnchor(null);
    onApply(locations);
  };
  const resetLocationFilter = e => {
    e.preventDefault();
    e.stopPropagation();
    onApply([]);
  };

  return (
    <div>
      <Button
        styleName={cn('LocationPickerTrigger', { fill: showCounter })}
        onClick={handleOpen}
        color="accent"
        border
      >
        <Icon name="location" styleName="left-icon" />
        {formatMessage({ id: 'dashboard.filter.location' })}
        {showCounter && (
          <Fragment>
            :{locationSize}
            <Icon
              onClick={resetLocationFilter}
              styleName="right-icon"
              name="close"
            />
          </Fragment>
        )}
      </Button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div styleName="LocationPicker">
          {filterList.map(({ id, name, ...rest }) => (
            <div styleName="LocationPickerRow" key={id}>
              <Checkbox
                id={`location-${id}`}
                checked={locations.includes(id)}
                onChange={() => handleSelect(id)}
                size={14}
              >
                <div styleName="LocationPickerInfo">
                  <div styleName="strong">{name}</div>
                  {!isVirtualVisit && (
                    <div styleName="meta">{renderAddress(rest)}</div>
                  )}
                </div>
              </Checkbox>
            </div>
          ))}
          <div className="tr">
            <Button onClick={handleApply} color="primary">
              {formatMessage({ id: 'common.apply' })}
            </Button>
          </div>
        </div>
      </Popover>
    </div>
  );
}

LocationPicker.propTypes = {
  formatMessage: PropTypes.func,
  onApply: PropTypes.func,
  filterList: PropTypes.array,
  isVirtualVisit: PropTypes.bool,
  activeLocations: PropTypes.array,
};

export default CSSModules(LocationPicker, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/LocationPicker/index.jsx